import ev from "../util/enumValue";

enum TextAlignment {
    LEFT = ev('LEFT', 1),
    RIGHT = ev('RIGHT', 2),
    CENTER = ev('CENTER', 3),
    JUSTIFY = ev('JUSTIFY', 4)
}

export default TextAlignment;
